export default __webpack_public_path__ + "static/media/sneakers.e4f78e79.png";